import { getPartnerToken, partnerLogin } from '@/lib/api/partner-portal/partner-portal-api'
import { Turnstile } from '@marsidev/react-turnstile'
import { useEffect, useRef, useState } from 'react'
import { MdLogin, MdVpnKey } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY || ''

export default function PartnerLoginPage() {
    const [accessCode, setAccessCode] = useState('')
    const [turnstileToken, setTurnstileToken] = useState('')
    const [loading, setLoading] = useState(false)
    const turnstileRef = useRef<any>(null)
    const navigate = useNavigate()

    useEffect(() => {
        if (getPartnerToken()) {
            navigate('/partner/appointments', { replace: true })
        }
    }, [])

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()

        if (!accessCode.trim()) {
            toast.warning('Digite o código de acesso.')
            return
        }

        if (TURNSTILE_SITE_KEY && !turnstileToken) {
            toast.warning('Aguarde a verificação de segurança.')
            return
        }

        setLoading(true)

        const response = await partnerLogin(accessCode.trim(), turnstileToken)

        if (response.success) {
            navigate('/partner/appointments', { replace: true })
        } else {
            toast.error(response.error || 'Código de acesso invalido.')
            turnstileRef.current?.reset()
            setTurnstileToken('')
        }

        setLoading(false)
    }

    return (
        <div className="min-h-screen bg-base-200 flex items-center justify-center p-4" data-theme="atendimento">
            <div className="card w-full !max-w-md bg-base-100 shadow-xl">
                <div className="card-body">
                    <div className="text-center mb-6">
                        <div className="flex justify-center mb-4">
                            <div className="w-16 h-16 rounded-full bg-secondary/10 flex items-center justify-center">
                                <MdVpnKey className="text-secondary text-3xl" />
                            </div>
                        </div>
                        <h1 className="text-2xl font-bold text-base-content">
                            Portal do Parceiro
                        </h1>
                        <p className="text-base-content/60 mt-1">
                            Acesse seus agendamentos
                        </p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text font-medium">
                                    Código de Acesso
                                </span>
                            </label>
                            <input
                                type="text"
                                placeholder="Digite seu código de acesso"
                                className="input input-bordered w-full"
                                value={accessCode}
                                onChange={e => setAccessCode(e.target.value)}
                                disabled={loading}
                                autoFocus
                            />
                        </div>

                        {TURNSTILE_SITE_KEY && (
                            <div className="flex justify-center">
                                <Turnstile
                                    ref={turnstileRef}
                                    siteKey={TURNSTILE_SITE_KEY}
                                    onSuccess={setTurnstileToken}
                                    onError={() => setTurnstileToken('')}
                                    onExpire={() => setTurnstileToken('')}
                                    options={{ theme: 'light' }}
                                />
                            </div>
                        )}

                        <button
                            type="submit"
                            className="btn btn-secondary w-full"
                            disabled={loading || (!!TURNSTILE_SITE_KEY && !turnstileToken)}
                        >
                            {loading ? (
                                <span className="loading loading-spinner loading-sm" />
                            ) : (
                                <>
                                    <MdLogin className="text-lg" />
                                    Entrar
                                </>
                            )}
                        </button>
                    </form>

                    <div className="divider my-2" />

                    <div className="text-center">
                        <button
                            type="button"
                            className="btn btn-ghost btn-sm text-secondary"
                            onClick={() => navigate('/partner/forgot-code')}
                        >
                            Esqueci meu código
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
